<template>
  <div class="container my-4">
    <div class="d-flex align-items-center justify-content-between mt-3 mb-4 pb-4 border-bottom">
      <h4 class="mb-0">Komponenten</h4>
      <router-link :to="{ name: 'CreateComponentView' }" class="btn btn-outline-primary"><fa-icon :icon="['fas', 'plus']" class="mr-2" />Neue Komponente</router-link>
    </div>
    <div v-if="isLoading === false">
      <div class="card shadow-sm" v-if="komponenten.length >= 1">
        <div class="card-body border-bottom">
          <b-input placeholder="Durchsuchen" v-model="filter"></b-input>
        </div>
        <b-table striped hover :items="komponenten" :fields="fields" :filter="filter" class="mb-0">
          <template #cell(name)="row">
            <router-link 
              :to="{ 
                name: 'EditComponentView', 
                params: {
                  componentId: row.item.id
                }
              }"
              :style="blocked.some((e)=> e.uid == uid && e.docId == row.item.id && (e.timestamp.toDate() > new Date())) ? `color: rgb(40, 167, 69) !important;`: ``"
              v-if="blocked.some((e)=> e.docId == row.item.id && e.uid == uid && (e.timestamp.toDate() > new Date())) || !blocked.some((e)=> e.docId == row.item.id && (e.timestamp.toDate() > new Date()))">
              <b-icon icon="unlock-fill" v-show="blocked.some((e)=> e.uid == uid && e.docId == row.item.id)"></b-icon>
              {{row.item.data.name}}
            </router-link>
            <span v-else class="text-muted"><b-icon icon="lock-fill"></b-icon> {{row.item.data.name}}</span>
          </template>

          <template #cell(actions)="row">
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-outline-primary btn-sm mr-2" title="Duplizieren" v-on:click="dupliziereKomponente(row.item.id)"><fa-icon icon="clone" /></button>
              <button type="button" class="btn btn-danger btn-sm" title="Löschen" v-on:click="loescheKomponente(row.item.id, row.item.data.name)"><fa-icon icon="trash" /></button>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <SpinnerComponent v-else />
  </div>
</template>

<script>
import { firestore } from "../plugins/firebase"
import { collection, getDocs, query, orderBy, getDoc, doc, addDoc, deleteDoc, onSnapshot, where} from "firebase/firestore"
import { auth } from '../plugins/firebase'

import SpinnerComponent  from '../components/SpinnerComponent'
export default {
  name: 'ComponentsView',
  components: {
    SpinnerComponent
  },
  computed: {
    deviceName: function() {
      return decodeURI(this.$route.query.deviceName)
    },
    configurationId: function() {
      return decodeURI(this.$route.query.configurationId)
    },
    refComponent: function() {
      return this.$route.query.refComponent
    },
    refTitle: function() {
      return decodeURI(this.$route.query.refTitle)
    }
  },
  data() {
    return {
      isLoading: true,
      komponenten: [],
      filter: '',
      unsubscribe: false,
      uid: "",
      blocked: [],
      fields: [
        {
          key: 'name',
          label: 'Bezeichnung'
        },
        {
          key: 'actions',
          label: ''
        }
      ]
    }
  },
  async beforeMount() {
    await this.ladeKomponenten()
    //this.loadListOfBlockedComponents()
    this.uid = auth.currentUser.uid
  },
  destroyed(){
    this.unsubscribe()
  },
  methods: {
    async loadListOfBlockedComponents(){
      const q = query(collection(firestore, "blockedKomponent"), where("timestamp", ">", new Date()));
      this.unsubscribe = onSnapshot(q, (querySnapshot) => {
        const blocked = [];
        querySnapshot.forEach((doc) => {
          blocked.push({docId:doc.id, uid:doc.data().uid, timestamp: doc.data().timestamp});
        });
        this.blocked = blocked
        console.log(blocked)
      });
    },
    ladeKomponenten: async function() {

      const q = query(collection(firestore, 'komponenten'), orderBy("name", "asc") )

      await getDocs(q)
      .then(docs=>{
        this.isLoading = false
        docs.forEach(document => {
          const element = {
            id: document.id,
            data: document.data()
          }
          this.komponenten.push(element)
        })
      })
      .catch(err=>{
        console.error(err)
      })

      
    },
    dupliziereKomponente: async function(id) {
      let data = await  getDoc(doc(firestore, "komponenten", id))
                          .then(document => {
                            if (document.exists) {
                              return document.data()
                            } else {
                              this.$bvModal.msgBoxOk('Die Komponente konnte nicht duplizieret werden.', {
                                title: '',
                                okVariant: 'primary',
                                okTitle: 'OK',
                                hideHeaderClose: false,
                                noCloseOnBackdrop: true
                              })
                              .catch(error => console.error(error)) // eslint-disable-line no-console
                            }
                          })
                          .catch(error => console.error(error)) // eslint-disable-line no-console

      data.name += ' - Kopie'

      addDoc(collection(firestore, "komponenten"), data)
      .then(() => {
        this.komponenten = []
        this.ladeKomponenten()
      })
      .catch(error => console.error(error)) // eslint-disable-line no-console
    },
    loescheKomponente: function(id, name) {
      this.$bvModal.msgBoxConfirm(`Soll die Komponente "${name}" wirklich gelöscht werden?`, {
        title: '',
        okVariant: 'danger',
        okTitle: 'OK',
        cancelTitle: 'Abbrechen',
        hideHeaderClose: false,
        noCloseOnBackdrop: true
      })
      .then(value => {
        if (value === true) {
          deleteDoc(doc(firestore, "komponenten", id))
          .then(() => {
            for(let i = 0; i < this.komponenten.length; i++){ 
              if (this.komponenten[i].id === id) {
                this.komponenten.splice(i, 1)
                i--
              }
            }
          })
          .catch(error => console.error(error)) // eslint-disable-line no-console
        }
      })
      .catch(error => console.error(error)) // eslint-disable-line no-console
    }
  }
}
</script>